export const SET_INITIAL_STATE = 'SET_INITIAL_STATE';

// Get reports
export const REQUEST_REPORTS_DATA = 'REQUEST_REPORTS_DATA';
export const RECEIVE_REPORTS_DATA = 'RECEIVE_REPORTS_DATA';
export const REPORTS_SERVICE_ERROR = 'REPORTS_SERVICE_ERROR';
export const SET_PAGE_INDEX = 'SET_PAGE_INDEX';

// create, delete & download busy status
export const SET_CREATE_BUSY_STATUS = 'SET_CREATE_BUSY_STATUS';
export const SHOW_DELETE_POPUP = 'SHOW_DELETE_POPUP';
export const HIDE_DELETE_POPUP = 'HIDE_DELETE_POPUP';
export const SHOW_DELETE_PROGRESS = 'SHOW_DELETE_PROGRESS';
export const SHOW_DOWNLOAD_POPUP = 'SHOW_DOWNLOAD_POPUP';
export const HIDE_DOWNLOAD_POPUP = 'HIDE_DOWNLOAD_POPUP';
export const SET_CIIACCESS_BUSY_STATUS = 'SET_CIIACCESS_BUSY_STATUS';
export const SHOW_EXPORT_PROGRESS = 'SHOW_EXPORT_PROGRESS';
export const SHOW_CLIENTS_EXPORT_PROGRESS = 'SHOW_CLIENTS_EXPORT_PROGRESS';